var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input',{attrs:{"disabled":_vm.disabled,"placeholder":_vm.placeholder,"type":"search","icon-right":"search","expanded":""},on:{"input":_vm.setValue},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }